/* Built In Imports */
// import { useRouter } from 'next/router';
"use client";
import Script from 'next/script';
import { Fragment, useEffect, useRef, useState } from 'react';

/* External Imports */
import { Box, Divider, Flex, Heading, Text, useBreakpointValue } from '@chakra-ui/react';
import parser from 'html-react-parser';
import LiteYouTubeEmbed from 'react-lite-youtube-embed';

/* Internal Imports */
/* Components */
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';
// import SubscribeContent from '@components/UI/Subscribe/SubscribeContent';
import { ShortCodeProcess } from '@components/Utility/ArticleParser/ShortCode';
import SocialIcon from '@components/Utility/SocialIcon';
import { setAudioPlayer } from '@components/Utility/utils';
import config from '@config';
import { LangStyle } from 'constants/index';
// import LikeBookmark from '@components/Utility/LikeBookmark';

/* Services */
/* Styles */
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import { modifyDatoImgUrlToStatic } from '../../../app/landing_pages/karma/Components/utils';

/**
 * Renders the Article component
 *
 * @param {object} articleData - data
 * @param {string} language - Language of the page
 * @param {boolean} isLikeBookmarkVisible
 * @param {Array} updateCards
 * @returns {ReactElement} Article component
 */

const Article = ({
  articleData,
  language,
  isLikeBookmarkVisible,
  updateCards,
  type,
}) => {
  let h2FontSize = useBreakpointValue({ base: '26px', md: '40px' })
  let quoteFontSize = useBreakpointValue({base: '26px', md: '40px'})
  let quoteFontLineHeight = useBreakpointValue({base: '30px', md: '50px'})
  // console.log("articleDataaaaaaaaaaaaaa", type, articleData);

  // const router = useRouter();
  // const { client } = router.query;
  const [showBreadCrumb, setShowBreadCrumb] = useState(true);
  const [isAudioLoad, setAudioLoad] = useState(false);
  const [youtubeID, setYoutubeID] = useState('');
  const options = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  };
  const date = new Date(articleData?.createdAt).toLocaleDateString(
    'en-US',
    options
  );
  const imgDivRef = useRef(null);
  let htmlDivRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const handleAudioClick = () => {
    if (!isAudioLoad) {
      setAudioLoad(true);
    }
  };

  // const langFont = {
  //   hi: 'Mukta',
  //   ta: 'MuktaMalar',
  // };

  let langClass = '';
  if (language === 'ta' || language === 'hi') {
    langClass = 'lang-' + language;
  }

  let body = modifyDatoImgUrlToStatic(articleData?.body)
  const articleBody = (body && ShortCodeProcess(body.toString(), undefined, undefined, true)) || '';
  let audioPlayerHeight = useBreakpointValue({base: '40px', md: "80px"})
  let playIconSize = useBreakpointValue({base: '20px', md: "40px"})
  let playIcon2Size = useBreakpointValue({base: '14px', md: "40px"})
  let audioPlayerMt = useBreakpointValue({base: "-6px", md: '-6px'})
  let timelineMt = useBreakpointValue({base: '22px', md: '38px'})
  let timelineWidth = useBreakpointValue({base: '63%', md: "75%"})
  let timelineLeftMargin = useBreakpointValue({base: '47px', md: '85px'})
  let timelineHeight = useBreakpointValue({base: '2px', md: '4px'})

  let sadhguruSignFontSize = useBreakpointValue({base: '16px', md: '20px'})
  let sadhguruSignSize = useBreakpointValue({base: '97px 45px', md: '122px 57px'}) 
  const audioRef = useRef(null);

  useEffect(() => {
    // if (
    //   router.asPath.includes('client=sadhguru-app') ||
    //   client === 'sadhguru-app'
    // ) {
    //   setShowBreadCrumb(false);
    // } else {
    //   setShowBreadCrumb(true);
    // }
    if (typeof window !== 'undefined' && type == 'audio' && isAudioLoad) {
      audioRef.current = new Audio(articleData?.mediaUrl[0]?.embedUrl)
      setAudioPlayer(articleData?.mediaUrl[0]?.embedUrl, undefined, audioRef.current);
    }
    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current = null;
      }
    }
  }, [isAudioLoad]);

  useEffect(() => {
    if (type === 'video') {
      const url = articleData?.mediaUrl[0]?.embedUrl;
      const VID_REGEX =
        /(?:youtube(?:-nocookie)?\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
      let id = '';
      if (url != '') {
        id = url?.match(VID_REGEX)[1];
        setYoutubeID(id);
      }
    }
  });

  return (
    <Fragment>
      <Box width="100%" textAlign="center" >
        <Box
        >
          {(
            <Box
              backgroundColor="#EFE7D6"
            mb={{ base: '-20px', md: '-200px' }}
            >
              <Box>
                <Text
                  display={'inline-block'}
                  width={{ base: '92%', md: "100%" }}
                  maxWidth="850px"
                  textAlign="center"
                  fontFamily={'var(--AustinMedium)'}
                  fontSize={{ base: '26px', md: '46px' }}
                  lineHeight={{ base: '110%', md: '60px' }}
                  color="#B7870C"
                  p={{
                    base: '19px 16px',
                    md: '27px 56px 16px',
                    lg: '55px 0px 24px',
                  }}                  
                  mt={{base: '1rem', md: '0px'}}
                  fontWeight={'500'}
                >
                  {articleData?.title}
                </Text>
                {type==='poem' ? 
                <Box display={'flex'} justifyContent={'center'}>
                <LazyLoadImageComponent 
                src={'https://static.sadhguru.org/d/46272/1754905094-karmapoemheaderdivider.png'}   
                width={{base: '142px', md: 'auto'}}
                height={{base: '24px', md: "auto"}}  
                mb={{base: '-10px', md: "0px"}}        
                />
                </Box> : null}
              </Box>
              {type != 'poem' ? 
              <Box mb={{ base: '1rem', md: '3rem' }}>
                <Text
                  display={'inline-block'}
                  width={{ base: '92%', md: "100%" }}
                  maxWidth="850px"
                  textAlign="center"
                  fontFamily={'var(--FedraSansStd-book)'}
                  fontSize={{ base: '16px', md: '20px' }}
                  lineHeight={{ base: '26px', md: '34px' }}
                  color="#000000"
                  fontWeight={'400'}
                >
                  {articleData?.summary}
                </Text>
                </Box> : <Flex
                  direction="column" alignItems={'center'} width={'100%'}
                  fontFamily={'var(--FedraSansStd-book)'}
                  fontStyle={'italic'}
                  color={'#000'}
                  fontSize={{
                    base: '16px',
                    md: '18px',
                  }} lineHeight={{base: '26px', md: '32px'}} className="articlebody">
                  <Box
                    width={{ base: '92%', md: '784px' }}
                  >
                    {parser(articleBody)}
                  </Box>
                  {/* <Box display={'flex'} justifyContent={'center'} mt={'30px'} mb={'40px'}>
                    <LazyLoadImageComponent
                      src={'https://www.datocms-assets.com/46272/1754907500-sadhgurusignatureblackfont.png'}
                    />
                  </Box> */}
                </Flex>}
            <Box
            display={'inline-block'}
            >
              {type === 'video' ? (
                articleData?.mediaUrl[0]?.embedUrl && (
                  <Box
                    pos="relative"
                    w={{ base: '100%', md: '96%', lg: '100%' }}
                    m="0 auto 30px"
                    maxH="477px"
                  >
                    <LiteYouTubeEmbed id={youtubeID} cookie={true} />
                  </Box>
                )
              ) : (
                <LazyLoadImageComponent
                  maxWidth={{ base: '100%', md: '784px' }}
                  src={
                    modifyDatoImgUrlToStatic(articleData?.heroImage?.url)
                  }
                  alt={
                    articleData?.heroImage?.alt
                  }
                  title={
                    articleData?.heroImage?.alt
                  }
                />
              )}
              
            {type == 'audio' &&
              articleData?.mediaUrl[0]?.embedUrl && (
                <Box 
                maxWidth={{ base: '100%', md: '784px' }} className="audio-player">
                  <Box className="timeline">
                    <Box className="progress"></Box>
                  </Box>
                  <Box className="controls">
                      <Box className="play-container" onClick={handleAudioClick}
                          height={{base: '0px', md: '50px'}} mt={{base: '4px', md: "0px"}}>
                        <Box
                          className={`toggle-play ${isPlaying ? 'pause' : 'play'}`}
                          width={playIconSize}
                          height={playIconSize}
                          pt={'4px'}
                          onClick={() => {
                            handleAudioClick();
                            setIsPlaying(!isPlaying);
                          }}
                        >
                          {isPlaying ? <svg width={playIconSize} height={playIconSize} viewBox={`0 0 40 40`} fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="20" cy="20" r="20" fill="white" />
                            <path d="M15.3335 14.75H18.8335V25.25H15.3335V14.75Z" fill="#B7870C" />
                            <path d="M21.1668 14.75H24.6668V25.25H21.1668V14.75Z" fill="#B7870C" />
                          </svg>
                            : <svg width={playIconSize} height={playIconSize} viewBox={`0 0 40 40`} fill="none" xmlns="http://www.w3.org/2000/svg">
                              <circle cx="20" cy="20" r="20" fill="white" />
                              <path d="M25.5563 19.9989L16.1118 14.4434V25.5545L25.5563 19.9989Z" fill="#B7870C" />
                            </svg>
                          }
                        </Box>
                      </Box>
                    <Box className="time" height={{base: '31px', md: '65px'}}>
                      <Box className="current"></Box>
                      <Box className="length"></Box>
                    </Box>
                    <Box className="volume-container">
                      <Box className="volume-button">
                        <Box className="volume icono-volumeMedium"></Box>
                      </Box>
                      <Box className="volume-slider">
                        <Box className="volume-percentage"></Box>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              )}
            </Box>
            </Box>
          )}

        {type != 'poem' ? 
        <Flex bgColor={'#fff'} ref={htmlDivRef} pt={{base:"20px", md: '220px'}}
            direction="column" alignItems={'center'} width={'100%'}
            fontFamily={
                LangStyle[language]?.articleFontFamily
                    ? LangStyle[language]?.articleFontFamily
                    : 'var(--FedraSansStd-book)'
            }
            fontSize={{
                base: '16px',
                md: '18px',
                lg: '20px',
            }} className="articlebody">
            <Box
                width={{ base: '92%', md: '784px' }}
            >
                {parser(articleBody)}
            </Box>
        </Flex> : <Box bgColor={'#fff'} pt={{base:"20px", md: '220px'}}/>}
        </Box>
      </Box>
      <style global jsx>
            {`
          .articlebody-arabic {
            direction: rtl;
          }
          .text-dir {
            direction: rtl;
            unicode-bidi: bidi-override;
          }
          strong {
            font-family: var(--FedraSansStd-medium) !important;
            font-weight: 500 !important;
          }
          hr {
            border-color: #eee;
          }
          table p {
            margin: 0 0 25px 0 !important;
          }
          td p {
            margin: 0 0 16px 0 !important;
          }
          .articlebody ol,
          .articlebody ul {
            padding-left: 1.5em;
          }
          .articlebody ul li,
          .articlebody ol li {
            padding: 3px 0.6vw;
          }
          .articlebody p {
            margin: 25px 0;
            word-break: break-word;
            direction: ${LangStyle[language]?.direction
                    ? LangStyle[language].direction
                    : 'none'};
            unicode-bidi: ${LangStyle[language]?.unicodeBidi
                    ? LangStyle[language].unicodeBidi
                    : 'none'};
          }
          .articlebody p iframe {
            width: 100%;
          }
          .articlebody blockquote {
            padding: 10px 20px;
            margin: 0 0 20px;
            font-size: 17.5px;
            border-left: 5px solid #eee;
          }
          .articlebody h1,
          .articlebody h2,
          .articlebody h3,
          .articlebody h4,
          .articlebody h5 {
            font-family: var(--AustinMedium);
            font-size: 36px;
            line-height: 1.11;
            text-align: ${LangStyle[language]?.alignRTL
                    ? LangStyle[language].alignRTL
                    : 'left !important'};
            color: #B7870C !important;
            direction: ${LangStyle[language]?.direction
                    ? LangStyle[language].direction
                    : 'none'};
            unicode-bidi: ${LangStyle[language]?.unicodeBidi
                    ? LangStyle[language].unicodeBidi
                    : 'none'};
            margin-top: 20px;
            margin-bottom: 10px;
            word-break: break-word;
          }

          .articlebody h2 {
            font-size: ${h2FontSize};
            line-height: 1.1;
            // Need to look into this, commenting as of now
            // float: left;
            // width: 100%;
          }

          .articlebody h3 {
            font-size: 27px !important;
          }

          .articlebody h4 {
            font-size: 24px !important;
            line-height: 1.21;
          }

          .articlebody h5 {
            font-size: 20px !important;
            line-height: 1.3;
          }

          .articlebody iframe {
            width: 100%;
            margin: 40px auto;
            // max-height: 405px;
            // min-height: 420px;
          }
          .articlebody a {
            color: #B7870C;
            border-bottom: 1px solid #B7870C;
            padding-bottom: 2px;
            cursor: pointer;
            word-break: break-word;
          }
          .articlebody a:hover {
            // background: #B7870C;
            // border-bottom: none;
            // color: #ffffff !important;
          }
          .articlebody a img {
            padding-bottom: 3px;
            position: relative;
            top: 17px;
          }
          .articlebody .isha-article-quote-bg {
            // background-image: url('${config.imgPath}/d/46272/1663649433-iaq.png');
            // background-position: 80% 100%;
            // background-repeat: no-repeat;
            // padding: 4vw 5vw 4vw;
            // margin: 2vw 3vw;
            // text-align: right;
            background: linear-gradient(90deg, rgba(183, 135, 12, 0.2) 0%, rgba(183, 135, 12, 0) 13.25%);
          }
          .article-right-blue {
            // height: auto;
            // right: 0;
            // width: auto;
            // // background-image: url('${config.imgPath}/d/46272/1663649491-article-side-img.png');
            // background-repeat: repeat-y;
            // background-position-x: right;
          }

          .isha-article-quote {
            /* width: 468px; */
            width: 84%;
            height: auto;
            font-size: ${quoteFontSize};
            line-height: ${quoteFontLineHeight};
            text-align: left;
            color: #030040;
            font-family: var(--AustinMedium);
            margin-left: 40px;
            padding-top: 20px; 
            padding-bottom: 20px;
          }

          .poemBlock {
            float: left;
            width: 100%;
            text-align: center;
            margin: 30px 0;
            padding: 50px 10px;
            padding-left: calc((100% - 750px) / 2);
            padding-right: calc((100% - 750px) / 2);
            // background-image: linear-gradient(to bottom, #f8f7ef 6%, #ffffff 99%);
            font-family: 'FedraSansStd-book-i';
            font-size: 24px;
            line-height: 1.17;
          }
          .poem-poemBlock {
            float: left;
            width: 100%;
            text-align: center;
            margin: 0 0;
            padding: 0 10px;
            padding-left: calc((100% - 750px) / 2);
            padding-right: calc((100% - 750px) / 2);
            background-color: #00334a;
          }

          .poemBlock .heading {
            float: left;
            width: 100%;
            font-family: 'FedraSansStd-medium', sans-serif;
            font-size: 48px;
            text-transform: uppercase;
          }
          .poem-poemBlock .heading {
            color: #faf7f0 !important;
            font-family: 'FedraSerifAStdBook' !important;
            margin: 4vw 0 0.4vw 0 !important;
            text-align: center !important;
            width: 100%;
            font-size: 45px;
            line-height: 1.38;
            letter-spacing: 1px;
            background-position: center bottom !important;
            min-height: auto !important;
            padding-bottom: 49px !important;
            background-image: url(${config.imgPath}/d/46272/1663645833-flower-divider-horizontal-new.svg);
            background-repeat: no-repeat;
          }

          .poemBlock .dividerimg {
            float: left;
            width: 100%;
            margin: 30px 0;
          }
          .poemBlock .dividerimg img {
            float: unset;
            width: auto;
          }
          .poem-poemBlock .poem {
            font-family: 'FedraSansStd-book-i', sans-serif;
            font-size: 24px;
            color: #dfd6c4;
            clear: both;
            padding-top: 5px;
          }
          .poem-poemBlock .poem p {
            margin: 20px 0;
            line-height: 1.17;
            letter-spacing: 1px;
          }
          .isha-article-caption,
          .isha-article-downloadmsg {
            color: #8a8173;
            height: auto !important;
            font-family: 'FedraSansStd-book-i';
            font-size: 20px;
            line-height: 1.7;
            text-align: center;
            margin-bottom: 32px;
          }
          .isha-article-caption {
            display: none;
          }
          .isha-article-downloadmsg .desktop {
            display: block;
          }
          .isha-article-downloadmsg .mobile {
            display: none;
          }
          .image-shortcode {
            text-align: center;
          }
          .image-shortcode.left {
            display: block;
            height: auto;
            float: left;
            width: 100%;
          }
          .image-shortcode .isha-article-caption {
            margin: 0 auto !important;
            height: auto !important;
            margin-bottom: 40px !important;
          }
          .image-shortcode.left .isha-article-caption {
            float: left;
          }
          .divider {
            width: 100%;
            height: 2px;
            border: solid 1px #d33100;
            margin: 20px 0;
          }
          .dropcap {
            background: url('${config.imgPath}/d/46272/1663673807-invalid-name.png')
              no-repeat;
            width: 90px;
            height: 100px;
            text-align: center;
            float: left;
            margin: 10px 10px 10px -20px;
          }
          .dropcap .text {
            margin-top: -10px !important;
            font-size: 84px;
            font-family: 'FedraSerifAStdBook';
            margin-top: -18px;
            position: absolute;
            width: 100px;
            margin-left: -48px;
          }
          .sadhguru-signature {
            min-height: 150px;
            font-family: 'FedraSansStd-book';
            font-size: ${sadhguruSignFontSize};
            text-align: ${type==='poem' ? 'center' : 'left'};
            color: ${type === 'poem' ? '#000' : '#7d7c7a'};
            background: url('${config.imgPath}/d/46272/1663654954-signature_name.png')
              no-repeat;
            background-position: ${type === 'poem' ? 'center 65px' : '0% 100%'};
            background-size: ${type === 'poem' ? sadhguruSignSize : ''};  
            margin-bottom: ${type === 'poem' ? '0px' : '80px'};
            padding-top: 10px;
            letter-spacing: 1px;
            padding-bottom: 115px;
            clear: both;
          }
          .sadhguru-signature.white {
            background: url('${config.imgPath}/d/46272/1663673930-sadhguru_signature_white.svg')
              no-repeat 0% 100%;
            color: #fff;
          }
          .sadhguru-signature.white.center {
            background: url('${config.imgPath}/d/46272/1663673930-sadhguru_signature_white.svg')
              no-repeat center bottom;
            text-align: center;
          }
          .isha-ps {
            font-family: 'FedraSansStd-book-i';
            font-size: 18px;
            line-height: 1.61;
            color: #B7870C;
          }
          .quote {
            font-family: 'FedraSansStd-book';
            font-size: 20px;
            line-height: 1.7;
            text-align: left;
            color: #B7870C;
            margin-bottom: 2vw;
          }
          .toggle-box-head {
            font-family: var(--AustinMedium) !important;
            font-size: 30px !important;
            line-height: 1.1;
            color: #B7870C;
            margin-top: 20px;
            margin-bottom: 10px;
            font-weight: 300 !important;
          }
          .isha-audio-player {
            margin-top: 21px;
          }
          .audioplayer {
            display: flex;
            height: 80px;
            opacity: 0.84;
            background-color: #d8d8d8;
            padding: 0;
          }
          .audio {
            width: 720px;
            height: 80px;
            opacity: 0.9;
            color: #d8d8d8;
          }
          .timeline {
            width: ${timelineWidth};
            height: 2px;
            margin-top: ${timelineMt};
            float: left;
            background: #979797;
            padding: 0;
          }
          .mar-top30 {
            margin-top: 30px;
          }
          .tcenter {
            text-align: center;
          }
          .pButton {
            height: 80px;
            width: 60px;
            border: none;
            background-repeat: no-repeat;
            background-position: center;
            outline: none;
            font-family: 'FedraSansStd-medium';
            margin: 16px 0 0 17px;
            background: url('${config.imgPath}/d/46272/1663639558-play.svg')
              no-repeat;
          }
          .playhead {
            width: 17px;
            height: 17px;
            border-radius: 50%;
            margin-top: -9px;
            background: #B7870C;
          }
          .isha-image-credit {
            background: url('${config.imgPath}/d/46272/1663674009-camera.svg')
              no-repeat;
            background-position: left;
            padding-left: 28px;
            line-height: 25px;
          }
          .isha-image-credit a {
            font-family: 'FedraSansStd-book-i';
            font-size: 16px;
          }
          .introtext {
            font-family: 'FedraSansStd-book-i';
            font-size: 20px !important;
            line-height: 1.7;
            color: #B7870C;
            margin-top: -10px;
          }
          .btn-isha-1 {
            font-family: 'FedraSansStd-medium';
            color: #ffffff;
            background-color: #B7870C;
            padding: 7px 12px;
            margin-bottom: 0;
            font-size: 14px;
            text-align: center;
            white-space: nowrap;
            vertical-align: middle;
            touch-action: manipulation;
            cursor: pointer;
            user-select: none;
            background-image: none;
            border: 1px solid transparent;
            border-radius: 3px;
          }
          .btn-isha-1:hover {
            background-color: #000054;
            color: #fff;
            -webkit-transition: all 500ms ease;
            -moz-transition: all 500ms ease;
            -ms-transition: all 500ms ease;
            -o-transition: all 500ms ease;
            transition: all 500ms ease;
          }
          .isha-question {
            font-family: 'FedraSansStd-medium';
          }
          .isha-answer {
            font-family: 'FedraSansStd-book-i';
            font-size: 20px;
            line-height: 1.7;
            color: #B7870C;
          }
          .editor-desc {
            background: url('${config.staticPath}/assets/images/editor-note-divider.png')
              no-repeat;
            width: 100%;
            background-position: center top;
            margin-top: 40px;
            font-size: 20px;
            line-height: 1.7;
            text-align: left;
            color: #B7870C;
            font-family: 'FedraSansStd-book-i';
            text-align: center;
          }
          .editor-desc .editor-inner {
            padding-top: 40px;
            text-align: left;
          }
          .sadhguruImage {
            vertical-align: middle;
            width: 101px;
            height: 101px;
            background: url('${config.imgPath}/d/46272/1663637865-bitmap.png')
              no-repeat;
            background-position: ${LangStyle[language]?.alignRTL
                    ? LangStyle[language].alignRTL
                    : 'left'};
            float: ${LangStyle[language]?.alignRTL
                    ? LangStyle[language].alignRTL
                    : 'left'};
          }
          .youtube-iframe {
            width: 100% !important;
            height: 100% !important;
            max-height: 100%;
          }
          .twitter-iframe iframe {
            margin: 10px auto !important;
            max-height: 605px;
          }
          @media only screen and (max-width: 736px) {
            .isha-article-quote {
              font-size: 20px;
            }
          }
          @media only screen and (max-width: 500px) {
            :target::before {
              content: '';
              display: block;
              height: 55px;
              margin: -55px 0 0;
            }
            .articlebody table {
              width: 100% !important;
            }
            .editor-desc .editor-inner {
              padding: 40px 3%;
              font-size: 15px;
            }
            iframe {
              width: 100%;
              min-width: 300px !important;
              margin: 0 auto;
              min-height: auto;
            }
            .articlebody iframe {
              width: 100% !important;
              height: 200px;
              min-height: auto;
            }
            iframe #twitter-widget-0 {
              height: 300px;
            }

            .articlebody .isha-article-quote-bg {
              margin-left: -20px;
            }
            .isha-article-quote {
              width: 85%;
              margin-left: 0;
            }
            .poemBlock {
              padding-left: 20px;
              padding-right: 20px;
              font-size: 16px !important;
            }
            .poem-poemBlock .poem {
              font-size: 18px;
            }
            .poem-poemBlock .poem p {
              margin: 0 0 15px;
            }
            .poem-poemBlock .heading {
              margin: 4vw 0 1.4vw 0 !important;
            }
            .timeline {
              width: ${timelineWidth};
            }
            .isha-article-quote {
              font-family: ${LangStyle[language]?.articleFontFamily
                    ? LangStyle[language].articleFontFamily
                    : 'var(--AustinMedium)'};
              width: 84%;
              font-size: ${quoteFontSize};
              margin-left: 30px;
              line-height: 30px;
              font-weight: 500;
              // padding: 0 20px 0 0;
              // margin: 0 0 40px 40px;
            }
            .article-right-blue {
              // background-position-x: 95%;
            }
          }
          .audio-player {
            height: ${audioPlayerHeight};
            width: 100%;
            background: #EAEAEA;
            /* box-shadow: 0 0 20px 0 #000a; */
            font-family: arial;
            color: rgb(255 255 255);
            font-size: 0.75em;
            overflow: hidden;
            display: grid;
            grid-template-rows: 6px auto;
            opacity: 1;
            margin-top: ${audioPlayerMt};
          }
          .audio-player .timeline {
            background: #BABABA;
            // width: 78%;
            height: ${timelineHeight};
            left: ${timelineLeftMargin};
            position: relative;
            cursor: pointer;
            margin-top: ${timelineMt};
            // box-shadow: 0 2px 10px 0 #0008;
          }
          .audio-player .timeline .progress {
            background: #B7870C;
            width: 0%;
            height: ${timelineHeight};
            transition: 0.25s;
          }
          .audio-player .timeline .progress:after {
            width: 20px;
            background: red;
            height: 20px;
          }
          .audio-player .controls {
            display: flex;
            justify-content: space-between;
            align-items: stretch;
            padding: 0 20px;
          }
          .audio-player .controls > * {
            display: flex;
            justify-content: center;
            align-items: center;
          }
          .audio-player .controls .toggle-play.play {
            cursor: pointer;
            position: relative;
            height: ${playIcon2Size};
            width: ${playIcon2Size};
            border: none;
            background-repeat: no-repeat;
            background-position: center;
            outline: none;
            font-family: 'FedraSansStd-medium';
            margin: 10px 0 0 0;
            background: url(${config.imgPath}/d/46272/1663639558-play.svg)
              no-repeat;
          }
          .audio-player .controls .toggle-play.play:hover {
            transform: scale(1.1);
          }
          .audio-player .controls .toggle-play.pause {
            position: relative;
            height: ${playIcon2Size};
            width: ${playIcon2Size};
            border: none;
            background-repeat: no-repeat;
            background-position: center;
            outline: none;
            font-family: 'FedraSansStd-medium';
            margin: 10px 0 0 0;
            background: url(${config.imgPath}/d/46272/1663645770-pause.svg)
              no-repeat;
          }

          .audio-player .controls .time {
            display: flex;
            margin-left: auto;
            color: #333;
            // margin-top: -25px;
            font-family: 'FedraSerifAStdBook';
            font-size: 13px;
          }
          .audio-player .controls .time > * {
            padding: 2px;
          }
          .audio-player .controls .volume-container {
            cursor: pointer;
            position: relative;
            z-index: 2;
          }
          .audio-player .controls .volume-container .volume-button {
            // height: 26px;
            display: flex;
            align-items: center;
          }
          .audio-player .controls .volume-container .volume-button .volume {
            transform: scale(0.7);
          }
          .audio-player .controls .volume-container .volume-slider {
            position: absolute;
            left: -3px;
            top: 15px;
            z-index: -1;
            width: 0;
            height: 15px;
            background: white;
            box-shadow: 0 0 20px #000a;
            transition: 0.25s;
          }
          .audio-player
            .controls
            .volume-container
            .volume-slider
            .volume-percentage {
            background: coral;
            height: 100%;
            width: 75%;
          }
          .audio-player .controls .volume-container:hover .volume-slider {
            left: -123px;
            width: 120px;
          }
          .toc {
            height: 260px;
            width: 160px;
            display: inline-block;
            padding: 0 0 0.1em 0;
            margin: 0 0.2em 0.2em 0;
          }
          .toc p {
            margin: 0 0 25px 0 !important;
          }
          .toc a {
            border-bottom: none;
          }
          .toc:hover {
            opacity: 0.8;
          }
          .blue {
            background: #3f687d;
          }
          .green {
            background: #56714c;
          }
          .orange {
            background: #c46f17;
          }
          .gray {
            background: #535353;
          }
          .yellow {
            background: #914444;
          }
          .purple {
            background: #6d587a;
          }
          .indexnum {
            font-family: var(--AustinMedium);
            color: #fff;
            opacity: 0.2;
            font-size: 3em !important;
            line-height: 1em !important;
            position: absolute;
          }
          .indexcont {
            font-family: var(--AustinMedium);
            color: #fff;
            font-size: 1.5em;
            line-height: 1em;
            padding: 3em 0 0 0em;
            text-align: center;
          }
          @media only screen and (max-width: 480px) {
            .toc {
              height: 146px;
              width: 120px;
            }
            .indexcont {
              font-size: 1em;
              line-height: 1em;
              padding: 1.5em 0 0 0em;
              text-align: center;
            }
            .indexnum {
              font-size: 3em;
              line-height: 1em;
              position: absolute;
            }
            .isha-article-downloadmsg .desktop {
              display: none;
            }
            .isha-article-downloadmsg .mobile {
              display: block;
            }
          }
          .indexnum a {
            color: #ffffff;
          }
          .indexnum {
            opacity: 0.8;
          }
          .indexcont a {
            color: #ffffff;
            font-family: 'opensans';
          }
          .indexcont a:hover {
            background-color: transparent !important;
          }
          /* aligation article */
          .aligation-faq-block {
            float: left;
            width: 100%;
            padding-left: calc((100% - 750px) / 2);
            padding-right: calc((100% - 750px) / 2);
            margin-top: 20px;
            margin-bottom: 20px;
          }
          @media (max-width: 480px) {
            .aligation-faq-block {
              padding: 0 16px;
            }
          }
          .aligation-faq-block .faq-card {
            float: left;
            margin-bottom: 20px;
            text-align: left;
            line-height: 1.3em;
          }
          .aligation-faq-block .que {
            float: left;
            width: 100%;
            background-color: #d3c9ae;
            font-family: 'FedraSansStd-Book';
            font-size: 20px;
            color: #000000;
            padding: 15px;
          }
          .aligation-faq-block .ans {
            float: left;
            width: 100%;
            background-color: #f5f5f5;
            font-family: 'FedraSansStd-Book';
            font-size: 20px;
            color: #000000;
            padding: 15px;
          }
          .aligation-faq-block .ans a {
            color: #B7870C;
            text-decoration: none;
            cursor: pointer;
          }
          .aligation-faq-block .ans p {
            margin: 0;
          }
          /* aligation article */

          /* Language styles for future reference */
          .lang-ta .articlebody .isha-article-title {
            font-family: 'MuktaMalar' !important;
            line-height: 0.73;
            font-weight: bold;
            font-size: 43px;
          }
          .lang-ta .articlebody .isha-article-message {
            font-family: 'MuktaMalar' !important;
            font-style: inherit !important;
          }
          .lang-ta .articlebody h2,
          .lang-ta .articlebody h3,
          .lang-ta .articlebody h4,
          .lang-ta .articlebody h5 {
            font-family: 'MuktaMalar' !important;
            font-style: inherit !important;
          }
          .lang-ta .articlebody .article-desc-title,
          .lang-ta .articlebody strong,
          .lang-ta .articlebody p strong {
            font-family: 'MuktaMalar' !important;
            font-weight: bold !important;
          }
          .lang-ta .articlebody .isha-article-quote {
            font-family: 'MuktaMalar' !important;
          }
          .lang-ta .articlebody .isha-article-desc {
            font-family: 'MuktaMalar' !important;
          }
          .lang-ta .isha-daily-mystic-quote-carousel .quote-cards .content {
            font-family: 'MuktaMalar' !important;
          }
          .ta.cards .isha-card-podcast-title,
          .ta.cards .isha-article-topic,
          .ta.cards .isha-rp-desc,
          .ta.quote-cards .content {
            font-family: 'MuktaMalar' !important;
          }
          .ta.cards .isha-rp-desc {
            font-size: 15px !important;
          }

          .lang-te .articlebody .isha-article-title {
            font-family: 'Gautami' !important;
            font-size: 46px;
            line-height: 0.72;
            -webkit-text-stroke: 1.4px #000000;
          }
          .lang-te .articlebody .isha-article-message {
            font-family: 'Gautami' !important;
            font-size: 22px;
            line-height: 1.55;
            font-style: inherit !important;
          }
          .lang-te .articlebody .article-desc-title {
            font-family: 'Gautami' !important;
            font-size: 28px !important;
          }
          .lang-te .articlebody .isha-article-desc {
            font-family: 'Gautami' !important;
            font-size: 22px;
            line-height: 1.64;
          }
          .lang-te .isha-daily-mystic-quote-carousel .quote-cards .content {
            font-family: 'Gautami' !important;
          }
          .te.cards .isha-card-podcast-title,
          .te.cards .isha-article-topic,
          .te.cards .isha-rp-desc,
          .te.quote-cards .content {
            font-family: 'Mukta' !important;
          }

          .lang-hi .articlebody .isha-article-title {
            font-family: 'Mukta' !important;
            line-height: 0.73;
            font-weight: bold;
            font-size: 45px !important;
          }
          .lang-hi .articlebody .isha-article-message {
            font-family: 'Mukta' !important;
            font-size: 22px;
            line-height: 1.55;
            font-style: inherit !important;
          }
          .lang-hi .articlebody .isha-article-desc {
            font-family: 'Mukta' !important;
            font-size: 22px;
            line-height: 1.73;
          }
          .lang-hi .articlebody .article-desc-title {
            font-family: 'Mukta' !important;
            font-size: 30px !important;
            font-weight: bold;
            line-height: 1.13;
            color: #B7870C;
          }
          .lang-hi .articlebody .isha-article-desc {
            font-family: 'Mukta' !important;
            font-size: 22px;
            line-height: 1.73;
          }
          .lang-hi .isha-daily-mystic-quote-carousel .quote-cards .content {
            font-family: 'Mukta' !important;
          }
          .hi.cards .isha-card-podcast-title,
          .hi.cards .isha-article-topic,
          .hi.cards .isha-rp-desc,
          .hi.quote-cards .content {
            font-family: 'Mukta' !important;
          }

          .lang-ml .articlebody .isha-article-title,
          .lang-ml .articlebody .article-desc-title {
            font-family: 'NotoSansMalayalam-Bold';
            line-height: 0.77;
          }
          .lang-ml .articlebody .isha-article-message {
            font-family: 'NotoSansMalayalam-Bold' !important;
            font-size: 26px !important;
            font-style: inherit !important;
          }
          .lang-ml .articlebody .isha-article-desc {
            font-family: 'NotoSansMalayalam-Regular' !important;
            line-height: 1.8;
          }
          .lang-ml .articlebody .isha-article-quote {
            font-size: 24px;
            line-height: 1.54;
            font-family: 'NotoSansMalayalam-Regular' !important;
          }
          .lang-ml .isha-daily-mystic-quote-carousel .quote-cards .content {
            font-family: 'NotoSansMalayalam-Regular' !important;
          }
          .ml.cards .isha-card-podcast-title,
          .ml.cards .isha-article-topic,
          .ml.cards .isha-rp-desc,
          .ml.quote-cards .content {
            font-family: 'NotoSansMalayalam-Regular' !important;
          }
          .lang-ne .articlebody .isha-article-title,
          .lang-ne .articlebody .article-desc-title {
            font-family: 'NotoSans-Bold';
            line-height: 0.77;
          }
          .lang-ne .articlebody .isha-article-message {
            font-family: 'NotoSans-Bold' !important;
            font-size: 26px !important;
            font-style: inherit !important;
          }
          .lang-ne .articlebody .isha-article-desc {
            font-family: 'NotoSans-Regular' !important;
            line-height: 1.8;
          }
          .lang-ne .articlebody .isha-article-quote {
            font-size: 24px;
            line-height: 1.54;
            font-family: 'NotoSans-Regular' !important;
          }
          .lang-ne .isha-daily-mystic-quote-carousel .quote-cards .content {
            font-family: 'NotoSans-Regular' !important;
          }
          .ne.cards .isha-card-podcast-title,
          .ne.cards .isha-article-topic,
          .ne.cards .isha-rp-desc,
          .ne.quote-cards .content {
            font-family: 'NotoSans-Regular' !important;
          }

          .lang-hi .articlebody .isha-article-quote,
          .lang-te .articlebody .isha-article-quote,
          .lang-ta .articlebody .isha-article-quote {
            font-size: 20px;
            line-height: 1.42;
            font-family: 'MuktaMalar' !important;
            color: #B7870C !important;
            /* font-family: "Mukta" !important;*/
          }

          .lang-ar .articlebody .isha-article-quote {
            margin: 0 50px 0 0;
            color: #6f6358;
          }
          /* Language styles for future reference */
        `}
        </style>
    </Fragment>
  );
};

export default Article;
